import { merchantResultsTabService } from "services";

import { resultsConstants } from "./results.constants";

export const resultsActions = {
	getFinancials,
	getBankBalances,
};

function getFinancials(merchantId) {
	return dispatch => {
		dispatch(request());
		return merchantResultsTabService.getFinancials(merchantId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};
	function request() {
		return { type: resultsConstants.GET_FINANCIALS_REQUEST };
	}
	function success(financials) {
		return { type: resultsConstants.GET_FINANCIALS_SUCCESS, financials };
	}
	function failure(error) {
		return { type: resultsConstants.GET_FINANCIALS_ERROR, error };
	}
}

function getBankBalances(merchantId) {
	return dispatch => {
		dispatch(request());
		return merchantResultsTabService.getBankBalances(merchantId).then(
			result => dispatch(success(result)),
			error => dispatch(failure(error)),
		);
	};
	function request() {
		return { type: resultsConstants.GET_BANK_BALANCES_REQUEST };
	}
	function success(bankBalances) {
		return {
			type: resultsConstants.GET_BANK_BALANCES_SUCCESS,
			bankBalances,
		};
	}
	function failure(error) {
		return { type: resultsConstants.GET_BANK_BALANCES_ERROR, error };
	}
}
